import { mergeStyles, styled } from '@fluentui/react';
import * as React from 'react';
import { handleTabOnSearchIcon, getPullLeftClassName } from '../../../utilities';
import { getContactUsClassNames, getContactUsStyles, IContactUsStyles } from '../styles/contactUsStyles';
import { IStyledComponent } from '../styles/themesUI';
import { isRtl } from '../../../../web/utils/stringLoader';

interface NavBarProps {
    displayNamespace: string;
    backButtonDisabled: boolean;
    inArticle: boolean;
    backButtonAriaLabel: string;
    popHistory: () => {};
}

const BackButton = (props: { inArticle: boolean, ariaLabel: string, backButtonDisabled: boolean, historyPop: () => {} } & IStyledComponent<IContactUsStyles>) => {
    const contactUsClassNames = getContactUsClassNames(props.styles, { theme: props.theme });
    if (props.backButtonDisabled === true) {
        return (
            <a id="chat-nav-back-inactive" className={mergeStyles(contactUsClassNames.iconArrowBack, contactUsClassNames.chatNavBackInactive)} aria-label={props.ariaLabel} tabIndex={0} href="javascript:void(0)" > <span className="navBackIcon" /></a >
        );
    } else {
        return (
            <a
                id="chatNavBackActive"
                data-bi-bhvr="BACKBUTTON"
                data-bi-area="articleNavBar"
                data-bi-name="articleBackArrow"
                data-bi-formnm="maxFunnel"
                onKeyDown={props.inArticle ? handleTabOnSearchIcon : null}
                className={contactUsClassNames.iconArrowBack}
                aria-label={props.ariaLabel}
                tabIndex={0}
                onClick={props.historyPop}
                href="javascript:void(0)"
            >
                <span className="navBackIcon" />
            </a >
        );
    }
};

type INavBarProps = NavBarProps & IStyledComponent<IContactUsStyles>;

const NavBar: React.FunctionComponent<INavBarProps> = (props) => {
  return (
    <nav id="chatNav" className={'navbar navbar-fixed-top' + props.displayNamespace}>
      <div className={`navbar-header ${getPullLeftClassName(isRtl())}`} >
        <BackButton inArticle={props.inArticle} historyPop={props.popHistory} ariaLabel={props.backButtonAriaLabel} backButtonDisabled={props.backButtonDisabled} theme={props.theme} styles={props.styles} />
      </div>
    </nav>
  );
};

export default styled(NavBar, getContactUsStyles);
